import { BaseService } from '../types/index.js';
export class Ramp extends BaseService {
    getAchNFTToken(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/thirdPart/alchemy/token/nft',
            params,
        });
    }
    getAchNFTSignature(params) {
        return this._request.send({
            method: 'GET',
            url: '/api/app/thirdPart/alchemy/signature/api',
            params,
        });
    }
    getAchNFTOrderInfoByOrderId(params) {
        return this._request.send({
            method: 'GET',
            url: '/api/app/thirdPart/orders',
            params,
        });
    }
    getFiatList(params) {
        return this._request.send({
            method: 'GET',
            url: '/api/app/thirdPart/alchemy/fiatList',
            params,
        });
    }
    getCryptoList(params) {
        return this._request.send({
            method: 'GET',
            url: '/api/app/thirdPart/alchemy/cryptoList',
            params,
        });
    }
    getOrderQuote(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/thirdPart/alchemy/order/quote',
            params,
        });
    }
    getAchToken(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/thirdPart/alchemy/token',
            params,
        });
    }
    getOrderNo(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/thirdPart/order',
            params,
        });
    }
    getAchSignature(params) {
        return this._request.send({
            method: 'GET',
            url: '/api/app/thirdPart/alchemy/signature',
            params,
        });
    }
    sendSellTransaction(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/thirdPart/alchemy/transaction',
            params,
        });
    }
}
